export default function(selector) {
    const compareElements = document.querySelectorAll(selector);
    
    if (compareElements.length == 0) {
        return;
    }

    const isEmpty = object => Object.keys(object).length === 0;

    for (let i = 0, compareElementsLength = compareElements.length; i < compareElementsLength; i++) {
        compareElements[i].addEventListener('change', function(event) {
            $.ajax({
                url: saveCompare,
                type: "POST",
                data: ({type: $(this).data('type'),
                        id: this.value,
                        value: this.checked
                }),
                dataType: "json",
                success: function(result)
                {
                    dataLayer.push({
                        'event' : 'trackEvent',
                        'eventCategory' : 'Saved Vehicles',
                        'eventAction' : 'Vehicle Added',
                        'eventLabel' : 'Added',
                        'eventValue' : 0,
                    });
                    if (typeof result.count !== 'undefined') {
                        updateCompareCount(result.count);
                    }

                    $(this).trigger('compared', result);

                    if (!isEmpty(result.motability)) {
                        document.querySelectorAll('.mega-menu__compare-link').forEach(link => {
                            link.setAttribute('href', '/saved-vehicles/motability');
                        })
                        return;
                    }

                    if (!isEmpty(result.used)) {
                        document.querySelectorAll('.mega-menu__compare-link').forEach(link => {
                            link.setAttribute('href', '/saved-vehicles/used');
                        })
                        return;
                    }

                    document.querySelectorAll('.mega-menu__compare-link').forEach(link => {
                        link.setAttribute('href', '/saved-vehicles/new');
                    })
                }.bind(this)
            });
        });
    }
}